export default __webpack_public_path__ + "static/media/IPhone8.fe955d59.png";